<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div>
  <form #df="ngForm" novalidate (keydown.enter)="onSearchDueList()" class="formborder">
    <div class="row m-0 align-items-center">
      <div class="col-md-2 mb-4">
        <span>Type</span>
        <select name="CheckType" id="CheckType" [(ngModel)]="CheckType" class="form-control input-text-css">
          <option value="OD Cases">OD Cases</option>
          <option value="All">All</option>
        </select>
      </div>

      <div class="col-md-2 pb-4">
        <span> Branch</span>
        <div class="position-relative">
          <ng-multiselect-dropdown class="due-list-multiselect" name="SelectBranch" id="SelectBranch"
            [placeholder]="'Select Branch'" [data]="BranchesList" [settings]="branchDropdownSettings"
            [(ngModel)]="SelectBranch" (onSelect)="onBranchSelectionChange()" (onDeSelect)="onBranchSelectionChange()"
            (onSelectAll)="onBranchSelectionChange()" (onDeSelectAll)="onBranchSelectionChange()">
          </ng-multiselect-dropdown>
          <i class="fa-solid fa-angle-down dropdown-icon"></i>
        </div>
      </div>

      <div class="col-md-3 pb-4">
        <span>Product</span>
        <div class="position-relative">
          <ng-multiselect-dropdown class="due-list-multiselect" name="SelectProduct" id="SelectProduct"
            [placeholder]="'Select Product'" [data]="ProductList" [settings]="productDropdownSettings"
            [(ngModel)]="SelectProduct" (onSelect)="onProductSelectionChange()" (onDeSelect)="onProductSelectionChange()"
            (onSelectAll)="onProductSelectionChange()" (onDeSelectAll)="onProductSelectionChange()">
          </ng-multiselect-dropdown>
          <i class="fa-solid fa-angle-down dropdown-icon"></i>
        </div>
      </div>

      <div class="col-md-2 mb-4">
        <span class="required-lable">Bucket Slab</span>
        <select name="SlabId" id="SlabId" [(ngModel)]="SlabId" class="form-control input-text-css" required
          #refSlabId="ngModel" [ngClass]="{
            'is-invalid': df.submitted && refSlabId.invalid,
            'alert-warning':
              refSlabId.invalid &&
              (refSlabId.dirty || refSlabId.touched || refSlabId.untouched)
          }">
          <option value="" selected>Select Bucket</option>
          <option *ngFor="let row of SlabData" [value]="row.Id">
            {{ row.Slab_name }}
          </option>
        </select>
      </div>

      <div class="col-md-3 mb-3">
        <span>Collection Executive</span>
        <select name="collection_exec" id="collection_exec" #refSelectGender="ngModel" [(ngModel)]="collection_exec"
          class="form-control input-text-css">
          <option value="" selected>Select Collection Executive</option>
          <option *ngFor="let Coll_exce of CollectionExecutiveData" [value]="Coll_exce.EmpId">
            {{ Coll_exce.Emp_FirstName }}
          </option>
        </select>
      </div>

      <div class="col-md-2 mb-3">
        <span>Source Type</span>
        <div class="position-relative">
          <ng-multiselect-dropdown class="due-list-multiselect" name="SelectSourceType" id="SelectSourceType"
            #refSelectSourceType="ngModel" [ngClass]="{
              'is-invalid': df.submitted && refSelectSourceType.invalid,
              'alert-warning':
                refSelectSourceType.invalid &&
                (refSelectSourceType.dirty ||
                  refSelectSourceType.touched ||
                  refSelectSourceType.untouched)
            }" [placeholder]="'Select Source Type'" [data]="leadSourceDropdown" [settings]="sourceTypeDropdownSettings"
            (onSelect)="onSourceTypeSelectionChange()" (onDeSelect)="onSourceTypeSelectionChange()"
            (onSelectAll)="onSourceTypeSelectionChange()" (onDeSelectAll)="onSourceTypeSelectionChange()"
            [(ngModel)]="SelectSourceType">
          </ng-multiselect-dropdown>
          <i class="fa-solid fa-angle-down dropdown-icon"></i>
        </div>
      </div>

      <div class="col-md-2 mb-3">
        <span>Due Up To</span>
        <div class="datepicker_feild">
          <input [matDatepicker]="picker" dateConvert placeholder="DD/MM/YYYY" name="DueDateFrom" id="DueDateFrom"
            #refDueDateFrom="ngModel" class="form-control input-text-css" [(ngModel)]="DueDateFrom" [ngClass]="{
              'is-invalid': df.submitted && refDueDateFrom.invalid,
              'alert-warning':
                refDueDateFrom.invalid &&
                (refDueDateFrom.dirty ||
                  refDueDateFrom.touched ||
                  refDueDateFrom.untouched)
            }" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>

      <div *ngIf="shouldShowLeadSourceName()" class="col-md-3 mb-3">
        <div>
          <span>Source Name</span>
          <select name="LeadSourceName" id="LeadSourceName" #refLeadSourceName="ngModel" [ngClass]="{
              'is-invalid': df.submitted && refLeadSourceName.invalid,
              'alert-warning':
                refLeadSourceName.invalid &&
                (refLeadSourceName.dirty ||
                  refLeadSourceName.touched ||
                  refLeadSourceName.untouched)
            }" [(ngModel)]="LeadSourceName" class="form-control input-text-css">
            <option value="">Select Lead Reference</option>
            <option *ngFor="let partner of partnerDropdown" [value]="partner.PartnerId">
              {{ partner.Partner_Name }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-2 mb-3">
        <span>Select Type</span>
        <select name="SearchType" id="SearchType" class="form-control input-text-css" [(ngModel)]="SearchType">
          <option value="0">Select Case</option>
          <option value="1">Repossessed Case</option>
          <option value="2">Legal Case</option>
          <option value="3">Death/Theaft Case</option>
        </select>
      </div>

      <div class="col-md-2 mb-3">
        <span>Accounting Category</span>
        <select name="LoanAccountingCatId" id="LoanAccountingCatId" [(ngModel)]="LoanAccountingCatId"
          class="form-control input-text-css">
          <option value="0">Select Accounting Category</option>
          <option *ngFor="let AcCat of AccCatDropdown" [value]="AcCat.Loan_CategoryId">
            {{ AcCat.Loan_category }}
          </option>
        </select>
      </div>

      <div class="col-md-2 mb-3">
        <button type="button" (click)="onSearchDueList()" class="btn font-size-12 button-btn"
          [disabled]="!df.form.valid">
          Search
        </button>
      </div>

      <div class="col-md-4 mb-3" [hidden]="!dataSource">
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input type="text" id="FilterInputSearch" (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch" placeholder="What're you searching for?"
                class="form-control border-0 bg-light" />
              <div class="input-group-append">
                <button id="button-addon1" type="submit" class="btn btn-link text-primary">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>

  <div class="mt-3" [hidden]="!dataSource">
    <div class="">
      <div class="table-responsive table-striped" style="overflow: auto; height: 65vh">
        <table class="table-bordered" matSort mat-table [dataSource]="dataSource" matTableExporter
          #exporter="matTableExporter" id="CollectionFollowUp" style="text-align: center">
          <ng-container matColumnDef="Id">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="text-center">#</th>
            <td mat-cell *matCellDef="let row; let i = index" class="text-center">
              {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
            </td>
            <th mat-footer-cell *matFooterCellDef class="text-center"></th>
          </ng-container>

          <ng-container matColumnDef="Application_No">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="text-center">Application No</th>
            <td mat-cell *matCellDef="let row" class="text-center">{{ row.Application_No }}</td>
            <th mat-footer-cell *matFooterCellDef class="text-center"></th>
          </ng-container>

          <ng-container matColumnDef="LoanAcNo">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="text-center">Loan No</th>
            <td mat-cell *matCellDef="let row" class="text-center">{{ row.LoanAcNo }}</td>
            <th mat-footer-cell *matFooterCellDef class="text-center"></th>
          </ng-container>

          <ng-container matColumnDef="Product_Name">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="text-center">Product Name</th>
            <td mat-cell *matCellDef="let row" class="text-center">{{ row.Product_Name }}</td>
            <th mat-footer-cell *matFooterCellDef class="text-center"></th>
          </ng-container>

          <ng-container matColumnDef="Branch_Name">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="text-center">Branch Name</th>
            <td mat-cell *matCellDef="let row" class="text-center">{{ row.Branch_Name }}</td>
            <th mat-footer-cell *matFooterCellDef class="text-center">Total</th>
          </ng-container>

          <ng-container matColumnDef="CustomerName">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="text-center">Customer Name</th>
            <td mat-cell *matCellDef="let row" style="text-transform: capitalize" class="text-center">{{ row.CustomerName }}</td>
            <th mat-footer-cell *matFooterCellDef class="text-center"></th>
          </ng-container>

          <ng-container matColumnDef="Customer_PhoneNo">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="text-center">Customer Phone No</th>
            <td mat-cell *matCellDef="let row" class="text-center">{{ row.Customer_PhoneNo }}</td>
            <th mat-footer-cell *matFooterCellDef class="text-center"></th>
          </ng-container>

          <ng-container matColumnDef="Last_Recv_Date">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="text-center">Last Received Date</th>
            <td mat-cell *matCellDef="let row" class="text-center">{{ row.Last_Recv_Date }}</td>
            <th mat-footer-cell *matFooterCellDef class="text-center"></th>
          </ng-container>

          <ng-container matColumnDef="Total_OverDUE_EMI__Amount">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="text-center">Total Overdue EMI Amount</th>
            <td mat-cell *matCellDef="let row" class="text-center">{{ row.Total_OverDUE_EMI__Amount }}</td>
            <th mat-footer-cell *matFooterCellDef class="text-center">
              {{ totaltypewise("Total_OverDUE_EMI__Amount") }}
            </th>
          </ng-container>

          <ng-container matColumnDef="OverDUE_EMI">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="text-center">Overdue EMI No.</th>
            <td mat-cell *matCellDef="let row" class="text-center">{{ row.OverDUE_EMI }}</td>
            <th mat-footer-cell *matFooterCellDef class="text-center">
              {{ totaltypewise("OverDUE_EMI") }}
            </th>
          </ng-container>

          <ng-container matColumnDef="DPD_Days">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="text-center">DPD Days</th>
            <td mat-cell *matCellDef="let row" class="text-center">{{ row.DPD_Days }}</td>
            <th mat-footer-cell *matFooterCellDef class="text-center"></th>
          </ng-container>

          <ng-container matColumnDef="EMIType">
            <th mat-sort-header mat-header-cell *matHeaderCellDef class="text-center">EMI Type</th>
            <td mat-cell *matCellDef="let row" class="text-center">{{ row.EMIType }}</td>
            <th mat-footer-cell *matFooterCellDef class="text-center"></th>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="sticky-footer fontcolor"
            style="background: var(--theme-primary)"></tr>
          <tr mat-row (click)="highlightRow(row)" [class.highlight]="row.Loan_Id == selectedId"
            *matRowDef="let row; columns: displayedColumns"></tr>
          <tr mat-footer-row class="sticky-footer fontcolor" *matFooterRowDef="displayedColumns; sticky: true"
            style="background: var(--theme-primary)"></tr>
        </table>
      </div>
    </div>
  </div>

  <div class="row m-0 ml-3" [hidden]="!dataSource">
    <div class="col-md-4 mt-3">
      <button class="mt-3 btn font-size-12 button-btn" (click)="exportexcelNew()">
        <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
        Export
      </button>
    </div>
    <div class="col-md-8 mt-3">
      <mat-paginator #paginatorRef [pageSizeOptions]="[20, 50]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>

<table id="export-collection-followup" class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none">
  <tr>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Application No</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Loan No</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Product Name</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Branch Name</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Customer Name</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Customer Phone No</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Last Received Date</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Total Overdue EMI Amount</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Overdue EMI No.</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">DPD Days</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">EMI Type</th>
  </tr>
  <tr *ngFor="let x of JsonData; let i = index">
    <td>{{ x.Application_No }}</td>
    <td>{{ x.LoanAcNo }}</td>
    <td>{{ x.Product_Name }}</td>
    <td>{{ x.Branch_Name }}</td>
    <td>{{ x.CustomerName }}</td>
    <td>{{ x.Customer_PhoneNo }}</td>
    <td style="mso-number-format:'dd\/mm\/yy';">{{ formatDateForExcel(x.Last_Recv_Date) }}</td>
    <td>{{ x.Total_OverDUE_EMI__Amount }}</td>
    <td>{{ x.OverDUE_EMI }}</td>
    <td>{{ x.DPD_Days }}</td>
    <td>{{ x.EMIType }}</td>
  </tr>
  <tr>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td style="font-weight: bold; text-align: center">Total</td>
    <td></td>
    <td></td>
    <td style="font-weight: bold; text-align: center">{{ totaltypewise("Total_OverDUE_EMI__Amount") }}</td>
    <td style="font-weight: bold; text-align: center">{{ totaltypewise("OverDUE_EMI") }}</td>
    <td></td>
    <td></td>
  </tr>
</table>
